import React, {
  forwardRef,
  useRef,
  useCallback,
  useEffect,
  useState,
} from "react";
import {
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { useIntl } from "react-intl";
import html2canvas from "html2canvas";

const Graph = forwardRef(
  (
    {
      data,
      yAxisTicks,
      label,
      width,
      height,
      dataKey1,
      dataKey2,
      axisLine,
      type,
      linkLabel,
      barColor,
    },
    ref
  ) => {
    const chartRef = useRef(null);
    const intl = useIntl();
    const [, setContainerSize] = useState({ width: 0, height: 0 });
    useEffect(() => {
      if (chartRef.current) {
        setContainerSize({
          width: chartRef.current.offsetWidth,
          height: chartRef.current.offsetHeight,
        });
      }
    }, []);

    const downloadChartImage = useCallback(
      downloadChart(chartRef, intl, linkLabel),
      [chartRef]
    );

    ref.current = {
      downloadChartImage,
    };

    return (
      <div ref={chartRef} style={{ width: width }}>
        <ResponsiveContainer width={width} height={height}>
          <BarChart data={data} barSize={19}>
            <XAxis dataKey={dataKey1} axisLine={axisLine} />
            <YAxis axisLine={axisLine} ticks={yAxisTicks} label={label} />
            <Tooltip cursor={{ fill: "transparent" }} />
            <Bar dataKey={dataKey2} fill={barColor} />
            <Line type={type} dataKey={dataKey2} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
);

export default Graph;

function downloadChart(chartRef, intl, linkLabel) {
  return () => {
    const node = chartRef.current;
    // Call the downloadChartImage function of the Graph component only if it is mounted
    try {
      if (node) {
        html2canvas(node).then((canvas) => {
          const link = document.createElement("a");
          link.download = linkLabel;
          link.href = canvas.toDataURL();
          link.click();
        });
      }
    } catch (error) {}
  };
}
